import React, { useEffect } from "react";
import Paths from "./Path";
import Popup from "react-popup";
import { useDispatch } from "react-redux";
import { isOpen } from "./redux/alertSlice";

// ✅ Disable logs in production ONCE at module level - not inside component
if (process.env.REACT_APP_ENV === 'PRODUCTION') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

function Site() {
  const dispatch = useDispatch();

  // ✅ Popup listeners inside useEffect - not on every render
  useEffect(() => {
    const showHandler = () => dispatch(isOpen(true));
    const closeHandler = () => dispatch(isOpen(false));

    Popup.addShowListener(showHandler);
    Popup.addCloseListener(closeHandler);

    // ✅ Cleanup listeners on unmount
    return () => {
      Popup.removeShowListener?.(showHandler);
      Popup.removeCloseListener?.(closeHandler);
    };
  }, [dispatch]);

  return (
    <>
      <Popup closeBtn={false} />
      <Paths />
    </>
  );
}

export default Site;